<a
  ds-button
  #ref
  [variant]="config.variant"
  [intent]="config.intent"
  [disabledLink]="isDisabled"
  [routerLink]="routerLink"
  [queryParams]="queryParams"
  [fragment]="fragment"
  [queryParamsHandling]="queryParamsHandling"
  [state]="state"
  [attr.href]="href"
  [attr.target]="target"
  [attr.rel]="rel"
  [attr.aria-label]="config?.ariaLabel"
  [attr.aria-disabled]="isDisabled ? true : null"
  (click)="onClick($event, isDisabled)"
>
  {{ config.text }}
</a>
